import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
	getPeriodList as getPeriodListApi,
	updatePeriod as updatePeriodApi,
	getPeriodQuery as getPeriodQueryApi,
} from '../../helpers/period/backend_helper';

export const getPeriodList = createAsyncThunk(
	'period/getPeriodList',
	async params => {
		try {
			const response = getPeriodListApi(params);
			return response;
		} catch (error) {
			throw new Error(error);
		}
	}
);

export const getPeriodQuery = createAsyncThunk(
	'period/getPeriodQuery',
	async params => {
		try {
			const response = await getPeriodQueryApi(params);
			return response;
		} catch (error) {
			throw new Error(error);
		}
	}
);

export const updatePeriod = createAsyncThunk(
	'period/updatePeriod',
	async period => {
		try {
			const response = updatePeriodApi(period);
			toast.success('Período actualizado exitosamente', { autoClose: 3000 });
			return response;
		} catch (error) {
			toast.error('Error al actualizar el período.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);
